<template>  
  <div class="sub-nav">
    <p class="sub-nav__title">Jump to:</p>
    <div>
      <ul class="sub-nav__list">
        <li class="sub-nav__list-item" v-for="(option, index) in options" :key="index">
          <span class="sub-nav__link strong-bold" v-if="option.value === pagePath">
            {{option.label}}
          </span>
          <a class="sub-nav__link link link--text" v-else :href="option.value">
            <span class="link__content">{{ option.label }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SelectInput from '@/scripts/components/forms/SelectInput.vue'

export default {
  name: 'SubNav',
  components: {
    SelectInput
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    pagePath: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {
    triggerMobileLink (path) {
      if (path === window.location.pathname || path.length <= 0) {
        return
      }
      window.location.href = path
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-nav {
  margin-bottom: -16px;
  padding: 0;
  width: 100%;

  &__title {
    margin-bottom: 8px;
    font-size: rem(14);
    line-height: 1.14;
    text-align: center;

    @include tablet-up {
      margin-bottom: 16px;
      font-size: rem(18);
      line-height: 1.33;
      text-align: left;
    }
  }

  &__list {
    list-style: none;
    padding-left: 0;
    display: flex;
  }

  &__list-item {
    padding: 0 10px;
    font-size: rem(14);
    line-height: 1.33;
  }

  &__link {
    display: inline-block;
    font-size: inherit;
    line-height: inherit;

    &:hover {
      text-decoration: underline;
    }

    @include mobile-only {
      text-decoration: underline;
    }

    .link__content {
      font-size: inherit;
      line-height: inherit;
    }
  }

  .input--select {
    margin-bottom: 0;
  }
}
</style>
